export const dashboardRu = {
  // общие — DashboardNav
  'dashboard.nav.ariaLabel': 'Разделы панели управления',
  'dashboard.nav.overview': 'Обзор',
  'dashboard.nav.avatar': 'Портрет',
  'dashboard.nav.coins': 'Монеты',
  'dashboard.nav.contributions': 'Вклады',

  // общие — StatusBadge (статус вклада)
  'dashboard.status.draft': 'Черновик',
  'dashboard.status.submitted': 'Отправлено',
  'dashboard.status.communityReview': 'Общественное рецензирование',
  'dashboard.status.officialReview': 'Официальное рецензирование',
  'dashboard.status.approved': 'Одобрено',
  'dashboard.status.rejected': 'Отклонено',
  'dashboard.status.unknown': 'неизвестный',

  // общие — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'в ожидании',
  'dashboard.claimStatus.approved': 'одобрено',
  'dashboard.claimStatus.rejected': 'отклонено',

  // DashboardPage
  'dashboard.seo.title': 'Мой Grymwyrd',
  'dashboard.seo.description': 'Твои монеты, претензии, вклады и персонажи в вечных сумерках.',
  'dashboard.displayNameFallback': 'Странник',
  'dashboard.welcomeBack': 'С возвращением',
  'dashboard.editAvatar': 'Изменить портрет',
  'dashboard.loading': 'Собираем твою легенду…',
  'dashboard.avatarAlt': 'Портрет {name}',
  'dashboard.offlineNotice':
    'Живые данные профиля недоступны — показываем последнюю известную сессию и примеры контента.',

  // DashboardPage — карточка Монеты
  'dashboard.coins.title': 'Могильные монеты',
  'dashboard.coins.viewAll': 'Показать все',
  'dashboard.coins.unit': 'монет',
  'dashboard.coins.noActivity': 'Нет активности с монетами.',
  'dashboard.coins.fullHistory': 'Полная история и покупка монет',

  // DashboardPage — карточка Вклады
  'dashboard.contributions.title': 'Вклады',
  'dashboard.contributions.manage': 'Управлять',
  'dashboard.contributions.empty': 'Нет вкладов — напиши свой первый.',

  // DashboardPage — карточка Претензии
  'dashboard.claims.title': 'Заявленные места в мире',
  'dashboard.claims.empty': 'Ты еще не владеешь землей в Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · заявлено {date}',

  // DashboardPage — карточка Персонажи
  'dashboard.characters.title': 'Персонажи',
  'dashboard.characters.empty': 'Нет душ, привязанных к твоему имени.',
  'dashboard.characters.level': 'Уровень {level}',
  'dashboard.characters.unknown': 'Неизвестный',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Редактор портрета',
  'dashboard.avatarEditor.seo.description': 'Сформируй лицо, которое ты показываешь миру Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Редактор портрета',
  'dashboard.avatarEditor.errorNotImage': 'Этот файл не является изображением.',
  'dashboard.avatarEditor.errorNameRequired': 'Имя требуется, даже в темноте.',
  'dashboard.avatarEditor.portrait': 'Портрет',
  'dashboard.avatarEditor.portraitPreview': 'Предпросмотр портрета',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Предпросмотр портрета',
  'dashboard.avatarEditor.zoom': 'Масштаб',
  'dashboard.avatarEditor.zoomAria': 'Масштабировать портрет',
  'dashboard.avatarEditor.panHorizontal': 'Смещать портрет по горизонтали',
  'dashboard.avatarEditor.panVertical': 'Смещать портрет по вертикали',
  'dashboard.avatarEditor.uploadAria': 'Загрузить изображение портрета',
  'dashboard.avatarEditor.changeImage': 'Изменить изображение',
  'dashboard.avatarEditor.uploadImage': 'Загрузить изображение',
  'dashboard.avatarEditor.identity': 'Личность',
  'dashboard.avatarEditor.displayName': 'Имя профиля',
  'dashboard.avatarEditor.backstory': 'История',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Откуда ты пришел, и какую темную судьбу ты преследуешь?',
  'dashboard.avatarEditor.publicProfile': 'Публичный профиль',
  'dashboard.avatarEditor.publicVisible': 'Виден в Зале легенд.',
  'dashboard.avatarEditor.publicHidden': 'Скрыт от других странников.',
  'dashboard.avatarEditor.saving': 'Сохраняем…',
  'dashboard.avatarEditor.saveChanges': 'Сохранить изменения',
  'dashboard.avatarEditor.saved': 'Сохранено',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Касса еще недоступна — сундуки остаются заперты.',
  'dashboard.coinHistory.notEnoughCoins': 'Недостаточно монет для этого.',
  'dashboard.coinHistory.reasonWorldClaim': 'Заявка на место',
  'dashboard.coinHistory.reasonCosmetic': 'Косметика',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Потрачено {cost} монет на {name}.',
  'dashboard.coinHistory.seo.title': 'Могильные монеты',
  'dashboard.coinHistory.seo.description': 'Твой реестр монет, пополнения и товары мертвецов.',
  'dashboard.coinHistory.heading': 'Могильные монеты',
  'dashboard.coinHistory.balance': 'баланс',
  'dashboard.coinHistory.buyCoins': 'Купить монеты',
  'dashboard.coinHistory.packCoins': '{coins} монет',
  'dashboard.coinHistory.packBonus': ' + {bonus} бонус',
  'dashboard.coinHistory.summoningCheckout': 'Вызываем кассу…',
  'dashboard.coinHistory.purchase': 'Купить',
  'dashboard.coinHistory.spendCoins': 'Потратить монеты',
  'dashboard.coinHistory.insufficientCoins': 'Недостаточно монет',
  'dashboard.coinHistory.spending': 'Расходуем…',
  'dashboard.coinHistory.spendAmount': 'Потратить {cost}',
  'dashboard.coinHistory.historyTitle': 'История',
  'dashboard.coinHistory.tallyingLedger': 'Подводим реестр…',
  'dashboard.coinHistory.tableCaption': 'История транзакций с монетами',
  'dashboard.coinHistory.colReason': 'Причина',
  'dashboard.coinHistory.colAmount': 'Сумма',
  'dashboard.coinHistory.noTransactions': 'Нет транзакций.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Мои вклады',
  'dashboard.contributionsPage.seo.description':
    'Повествование, которое ты написал, и его прохождение через взор модераторов.',
  'dashboard.contributionsPage.heading': 'Вклады',
  'dashboard.contributionsPage.newContribution': 'Новый вклад',
  'dashboard.contributionsPage.loading': 'Разворачиваем твои свитки…',
  'dashboard.contributionsPage.empty': 'Ты еще не написал лор. Начни свой первый вклад.',
  'dashboard.contributionsPage.untitledDraft': 'Безымянный черновик',
  'dashboard.contributionsPage.moderator': 'Модератор:',
  'dashboard.contributionsPage.entryFallback': 'Запись',
  'dashboard.contributionsPage.errorNameRequired': 'Каждое творение нуждается в имени.',
  'dashboard.contributionsPage.modalTitle': 'Новый вклад',
  'dashboard.contributionsPage.type': 'Тип',
  'dashboard.contributionsPage.titleLabel': 'Название',
  'dashboard.contributionsPage.summaryLabel': 'Краткое описание',
  'dashboard.contributionsPage.saveDraft': 'Сохранить черновик',
  'dashboard.contributionsPage.submitting': 'Отправляем…',
  'dashboard.contributionsPage.submitForReview': 'Отправить на рецензирование',
} as const
